var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3792_109328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6484 20.5H5.1875C3.46432 20.5 2.0625 19.0982 2.0625 17.375V6.78906C2.0625 5.06589 3.46432 3.66406 5.1875 3.66406H12.6484C14.3716 3.66406 15.7734 5.06589 15.7734 6.78906V17.375C15.7734 19.0982 14.3716 20.5 12.6484 20.5ZM5.1875 5.22656C4.32599 5.22656 3.625 5.92755 3.625 6.78906V17.375C3.625 18.2365 4.32599 18.9375 5.1875 18.9375H12.6484C13.5099 18.9375 14.2109 18.2365 14.2109 17.375V6.78906C14.2109 5.92755 13.5099 5.22656 12.6484 5.22656H5.1875ZM18.8984 15.4219V3.625C18.8984 1.90182 17.4966 0.5 15.7734 0.5H7.10156C6.67004 0.5 6.32031 0.849731 6.32031 1.28125C6.32031 1.71277 6.67004 2.0625 7.10156 2.0625H15.7734C16.6349 2.0625 17.3359 2.76349 17.3359 3.625V15.4219C17.3359 15.8534 17.6857 16.2031 18.1172 16.2031C18.5487 16.2031 18.8984 15.8534 18.8984 15.4219Z",
    fill: "#FC686F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3792_109328"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy-icon.677e5e689a7a487aaff5a94c18bc6762.svg";
export { ForwardRef as ReactComponent };